import { forwardRef, SVGProps } from "react";

export const TextBoxIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(({ fill = "#515B6F", ...props }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    width="24px"
    viewBox="0 -960 960 960"
    fill={fill}
    {...props}
  >
    <path d="M480-80 373-240H160q-33 0-56.5-23.5T80-320v-480q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H587L480-80Zm0-144 64-96h256v-480H160v480h256l64 96Zm0-336Z" />
  </svg>
));
